export const inputStyles = {
  mb: 2,
  '& .MuiInputBase-input': {
    color: '#e7e3e3',
    backgroundColor: '#282f38 !important',
    borderRadius: '4px',
  },
  '& .MuiInputBase-input.Mui-disabled': {
    opacity: 1,
    WebkitTextFillColor: '#fff',
    color: '#fff',
  },
  '& .MuiInputLabel-root': {
    color: '#00EDC3 !important',
  },
  '& .MuiOutlinedInput-root': {
    backgroundColor: '#282f38 !important',
    '& fieldset': {
      borderColor: '#00EDC3',
    },
    '&:hover fieldset': {
      borderColor: '#00EDC3',
    },
    '&.Mui-focused fieldset': {
      borderColor: '#00EDC3',
    },
  },
  '& .MuiInputBase-input::placeholder': {
    color: '#e7e3e3',
    opacity: 0.7,
  },
  '& .MuiOutlinedInput-notchedOutline': {
    borderColor: '#00EDC3 !important',
  },
  '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
    borderColor: '#00EDC3 !important',
  },
  '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
    borderColor: '#00EDC3 !important',
  },
  '& input:-webkit-autofill': {
    WebkitBoxShadow: '0 0 0 1000px #282f38 inset',
    WebkitTextFillColor: '#e7e3e3',
    caretColor: '#e7e3e3',
  },
  '& input:-moz-autofill': {
    boxShadow: '0 0 0 1000px #282f38 inset',
    color: '#e7e3e3',
    caretColor: '#e7e3e3',
  },
};

export const buttonStyles = {
  backgroundColor: '#00EDC3',
  color: '#282f38',
  fontWeight: 500,
  '&:hover': {
    backgroundColor: '#00EDC3',
    opacity: 0.9,
  },

  '&.Mui-disabled': {
    backgroundColor: '#ccc',
    opacity: 0.7,
  },
};
